import { INavigationLink, TNavigationLinkType } from '../types';

export const NavigationLinkTypes = {
  About: 'about' as TNavigationLinkType,
  Builder: 'builder' as TNavigationLinkType,
  Features: 'features' as TNavigationLinkType,
  Infrastructure: 'infrastructure' as TNavigationLinkType,
  Map: 'map' as TNavigationLinkType,
  Neighbourhood: 'neighbourhood' as TNavigationLinkType,
  Objects: 'objects' as TNavigationLinkType,
  MainInfo: 'main_info' as TNavigationLinkType,
  DevelopmentStatus: 'development_status' as TNavigationLinkType,
};

export const navigationLinks: INavigationLink[] = [
  { label: 'Главное о КП', name: NavigationLinkTypes.MainInfo },
  { label: 'Развитие посёлка', name: NavigationLinkTypes.DevelopmentStatus },
  { label: 'Объекты', name: NavigationLinkTypes.Objects },
  { label: 'Особенности', name: NavigationLinkTypes.Features },
  { label: 'На карте', name: NavigationLinkTypes.Map },
  { label: 'Окрестности', name: NavigationLinkTypes.Neighbourhood },
  { label: 'Инфраструктура', name: NavigationLinkTypes.Infrastructure },
  { label: 'О поселке', name: NavigationLinkTypes.About },
  { label: 'О застройщике', name: NavigationLinkTypes.Builder },
];

export const fatNavigationLinks: INavigationLink[] = [
  { label: 'Главное о КП', name: NavigationLinkTypes.MainInfo },
  { label: 'Развитие посёлка', name: NavigationLinkTypes.DevelopmentStatus },
  { label: 'Объекты', name: NavigationLinkTypes.Objects },
  { label: 'На карте', name: NavigationLinkTypes.Map },
  { label: 'Особенности', name: NavigationLinkTypes.Features },
  { label: 'Окрестности', name: NavigationLinkTypes.Neighbourhood },
  { label: 'Инфраструктура', name: NavigationLinkTypes.Infrastructure },
  { label: 'О поселке', name: NavigationLinkTypes.About },
  { label: 'О застройщике', name: NavigationLinkTypes.Builder },
];
